import React from "react";

export const CONFIG = {
    paymentUrl: '',
    bookingEndpoint: '/api/vouchers/booking',
    loginEndpoint: '/login',
    getUserDataEndpoint: '/getCurrentUserAddress',
    checkUserEndpoint: '/login',
    privacyPolicyUrl: '/polityka-prywatnosci',
    changeUserPasswordUrl: '/change-password',
    USER_PANEL_URL: '/profil/details',
    currentLangPL: 'current-lang-pl',
    currentLangDE: 'current-lang-de',
    form_register: {
        name: '',
        surname: '',
        email: '',
        repeat_email: '',
        company: '',
        street: '',
        city: '',
        postal_code: '',
        comments: ''
    },
}